import React, { useState } from "react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    const api_url = process.env.REACT_APP_API_URL;
    const requestBody = {
      email: email,
    };

    try {
      const response = await fetch(`${api_url}/auth:reset_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.errorObject?.message || "Failed to send reset link.");
        setIsLoading(false);
        return;
      }

      const data = await response.json();
      if (data.success) {
        setIsSubmitted(true);
      } else {
        setErrorMessage(data.errorObject?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please check your connection and try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="d-flex h-100 w-100 justify-content-center align-items-center bg-light"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="bg-white rounded-4 p-5 d-flex flex-column shadow-lg"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        {!isSubmitted ? (
          <>
            <h3 className="text-start mb-4 text-primary">
              Forgot Your Password?
            </h3>
            <p
              className="text-start text-muted mb-4"
              style={{ fontSize: "14px" }}
            >
              Enter your email address, and we will send you a link to reset your password.
            </p>
            {errorMessage && (
              <div className="alert alert-danger text-center" role="alert">
                {errorMessage}
              </div>
            )}
            <form
              onSubmit={handleSubmit}
              className="d-flex flex-column form-floating flex-fill mb-3"
            >
              <div className="form-floating flex-fill mb-3">
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="example@domain.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="email" className="form-label">
                  Email Address
                </label>
              </div>
              <button
                type="submit"
                className="btn btn-primary w-100 mt-2 fw-bold"
                disabled={!email.trim() || isLoading}
              >
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <h4 className="text-success mb-3">Link Sent!</h4>
            <p className="text-muted">
              A reset link has been sent to your email. Please check your inbox
              and follow the instructions to reset your password.
            </p>
            <button
              className="btn btn-secondary mt-3 fw-bold"
              onClick={() => {
                window.location.href = "/login";
              }}
            >
              Go to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
